<template>
  <div class="p-2">
    <div
      class="ml-2 mr-2 data-list-item add"
      @click.stop="add"
    >
      <div class="item-img-cont add-title">
        <i class="fa fa-plus" />
      </div>
      <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
        <font-awesome-icon
          icon="calendar-check"
          class="card-body-icon"
        />
      </div>
    </div>

    <Transition name="fade">
      <conversion-task-type-model-list
        :codes="codes"
        :results="results"
        @edit="edit"
      />
    </Transition>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
    <base-modal v-if="editMode" hide-footer hide-header @close="editMode = false">
        <conversion-task-type-model-editor
          ref="conversion-task-type-editor"
          :codes="availableCodes"
          :conversion-models="results"
          :model="conversionModel"
          @close="showList"
          @close-and-update="closeAndUpdate"
        />
    </base-modal>
  </div>
</template>

<script>
import {restApi} from '@/components/mixins/RestApiMixin'
import {conversionModelHelper} from '@/components/mixins/ConversionMixin'
import ConversionTaskTypeModelList from './ConversionTaskTypeModelList'
import ConversionTaskTypeModelEditor from './ConversionTaskTypeModelEditor'
import BaseModal from "@/components/BaseModal";

export default {
    name: 'ConversionTaskTypeModels',
    components: {BaseModal, ConversionTaskTypeModelList, ConversionTaskTypeModelEditor},
    mixins: [restApi, conversionModelHelper],
    data: function () {
        return {
            results: [],
            conversionModel: null,
            editMode: false,
            codes: [],
            loading: false,
            searchCompanyId: null,
            company: null
        }
    },
    computed: {
        availableCodes() {
            let codes = []
            this.codes.forEach(code => {
                const existing = this.results.find(conversion => conversion.code.code === code.code)
                if (!existing) {
                    codes.push(code)
                }
            })
            return codes;
        }
    },
    mounted: function () {
        this.fetchModels()
        this.fetchForestCodes()
    },
    methods: {
        fetchForestCodes: function () {
            this.loading = true
            this.restFetch(this.forestCodeUrl, this.handleForestCodes)
        },
        handleForestCodes: function (response) {
            this.codes = response.data
            this.loading = false
        },
        fetchModels: function (companyId) {
            this.loading = true
            this.results = []
            this.searchCompanyId = companyId
            this.restFetch(this.taskTypeConversionUrl,  this.handleResponse)
        },
        handleResponse: function (response) {
            this.results = response && response.data ? response.data : []
            this.loading = false
        },
        add: function () {
            this.conversionModel = this.newTaskTypeConversionModel()
            this.editMode = true
        },
        edit: function (cModel) {
            this.conversionModel = cModel
            this.editMode = true
        },
        showList: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.showList()
            this.fetchModels(this.searchCompanyId)
        }
    }
}
</script>
